import { render } from "./PopupAuth.vue?vue&type=template&id=553bbd9a"
import script from "./PopupAuth.vue?vue&type=script&lang=js"
export * from "./PopupAuth.vue?vue&type=script&lang=js"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__